export default class Patientengruppe {

    public patientengruppe_id: number | null = null;
    public patientengruppe: string | null = null;
    public gueltig: string | null = null;


    constructor(data?: Partial<Patientengruppe>) {
        Object.assign(this, data);
    }
}
